import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import NavbarRight from "../components/NavbarRight";
export default {
  components: {
    NavbarRight: NavbarRight
  },
  computed: _objectSpread({}, mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    }
  }))
};